import { createSelector } from 'reselect';
import { groupSchema } from '@wix/da-shared-react/pkg/redux/normalizr/schemas/group';
import { getAllDataEntitiesForSchema } from '@wix/da-shared-react/pkg/redux/entities';
import { getIsWatchingProfileOwner } from './users';

export const getAllGroupsKeyedByIds = state =>
  getAllDataEntitiesForSchema(state, groupSchema);

export const getGroupsByIds = createSelector(
  [getAllGroupsKeyedByIds, (state, ids) => ids],
  (allGroupsKeyedByIds, ids) => ids.map(id => allGroupsKeyedByIds[id])
);

export const getPagePrivileges = state => state.pagePrivileges || {};
export const canPerformPageAction = (state, action: string) => {
  const pagePrivs = getPagePrivileges(state);
  return (
    !(action in pagePrivs) || pagePrivs?.[action] === true // assume authorized if not specified otherwise
  );
};

export const getIsGroupMember = state => getIsWatchingProfileOwner(state);
